import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [nlStatus, setNlStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [nlMessage, setNlMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setNlStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('company_alt') as string || '').trim();

    if (honeypotValue) {
      setNlStatus('success');
      setNlMessage('订阅成功！感谢您的关注。');
      form.reset();
      return;
    }

    formData.delete('company_alt');

    try {
      const formBody = new URLSearchParams();
      formData.forEach((value, key) => {
        formBody.append(key, value.toString());
      });

      const response = await fetch('https://readdy.ai/api/form/d9on5oosenbniolesi3g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setNlStatus('success');
        setNlMessage('订阅成功！感谢您的关注。');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (serverMsg.includes('spam')) {
          setNlStatus('success');
          setNlMessage('订阅成功！感谢您的关注。');
          form.reset();
        } else {
          setNlStatus('error');
          setNlMessage(serverMsg || '订阅失败，请稍后重试');
        }
      }
    } catch {
      setNlStatus('error');
      setNlMessage('网络错误，请检查网络后重试');
    } finally {
      setNlStatus((prev) => (prev === 'loading' ? 'idle' : prev));
    }
  };

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">
                  女神漫画
                </Link>
              </h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                免费全集漫画在线阅读平台，支持下拉式、弹窗、翻页等多种阅读模式。覆盖韩漫、日漫、国漫，每日更新，收藏追更不迷路。
              </p>
              <div className="flex gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2">
                {categories.slice(1, 7).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/korean" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    韩漫推荐
                  </Link>
                </li>
                <li>
                  <Link to="/category/japanese" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    日漫推荐
                  </Link>
                </li>
                <li>
                  <Link to="/category/chinese" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    国漫推荐
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@nvshenmanhua.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-6666</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区望京SOHO</span>
                </li>
              </ul>
              <div className="mt-4">
                <p className="text-xs text-foreground-500 mb-2">订阅我们的 newsletter</p>
                <form
                  className="flex gap-2"
                  data-readdy-form
                  onSubmit={handleNewsletterSubmit}
                >
                  <input
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="sp-hp"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="输入邮箱"
                    required
                    className="flex-1 px-3 py-2 rounded-lg bg-background-800 border border-background-700 text-sm text-foreground-200 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
                  />
                  <button
                    type="submit"
                    disabled={nlStatus === 'loading'}
                    className="px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
                  >
                    {nlStatus === 'loading' ? '...' : '订阅'}
                  </button>
                </form>
                {nlStatus === 'success' && (
                  <p className="text-xs text-accent-400 mt-2">{nlMessage}</p>
                )}
                {nlStatus === 'error' && (
                  <p className="text-xs text-primary-400 mt-2">{nlMessage}</p>
                )}
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 女神漫画 版权所有 | 京ICP备2022000001号
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}